import { HttpClient } from '@angular/common/http';
import { HttpResponsesHandlersFactory } from '../handlers/http-responses-handler';
import { BaseDataService } from './base.data.service';
import { Injectable } from '@angular/core';
import {
  ICostRejectionTemplate,
  ICostRejectionEmail,
  ICostRejectionSearch,
} from '../interfaces/cost-rejection-template';

@Injectable({
  providedIn: 'root',
})
export class CostRejectionTemplateService extends BaseDataService {
  url = '/api/costRejection';
  entityTitle = 'CostRejection';

  constructor(http: HttpClient, handlersFactory: HttpResponsesHandlersFactory) {
    super(http, handlersFactory);
  }

  search(filter: ICostRejectionSearch = {}): Promise<ICostRejectionTemplate[]> {
    console.log('FILTER ', filter);

    let params = this.constructHttpParams(filter);

    console.log('THIS URL ', this.url);

    return this.handleRequest<ICostRejectionTemplate[]>(
      this.http.get<ICostRejectionTemplate[]>(this.url, { params: params }),
      this.handlersFactory.getForReadAll(),
    );
  }

  delete(id) {
    const newUrl = this.url + '/' + id;

    return this.handleRequest<any>(
      this.http.delete<any>(newUrl),
      this.handlersFactory.getForDelete(this.entityTitle),
    );
  }

  getRejectionEmail(requestId, costRejectionId) {
    const newUrl = '/api/AdditionalCharge/' + requestId + '/reject/' + costRejectionId + '/prepare';
    return this.http.get<any>(newUrl).toPromise();
  }

  sendRejectionEmail(rejectionEmailDTO: ICostRejectionEmail) {
    const newUrl =
      '/api/AdditionalCharge/' + rejectionEmailDTO.additionalChargeId + '/sendRejection';
    return this.http.post<any>(newUrl, rejectionEmailDTO).toPromise();
  }

  create(costRejection: ICostRejectionTemplate) {
    if (costRejection.id == 0 || costRejection.id == null) {
      return this.handleRequest<any>(
        this.http.post<ICostRejectionTemplate>(this.url, costRejection),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    }
  }

  patch(id: number, patch: any) {
    if (id != 0 && id != null) {
      const newUrl = this.url + '/' + id;

      return this.handleRequest<any>(
        this.http.patch<ICostRejectionTemplate>(newUrl, patch),
        this.handlersFactory.getForUpdate(this.entityTitle),
      );
    }
  }
}
